import { render, staticRenderFns } from "./EditSatisfactionComponent.vue?vue&type=template&id=0028aff3&"
import script from "./EditSatisfactionComponent.vue?vue&type=script&lang=js&"
export * from "./EditSatisfactionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports